(() => {
  const sections = document.querySelectorAll('.home-accessories-promo');

  sections.forEach((section) => {
    const wireDialog = ({ dialogSelector, openSelector, closeSelector }) => {
      const dialog = section.querySelector(dialogSelector);
      const openButton = section.querySelector(openSelector);
      const closeButton = section.querySelector(closeSelector);

      if (!dialog || !openButton || !closeButton || typeof dialog.showModal !== 'function') {
        return null;
      }

      openButton.addEventListener('click', () => {
        dialog.showModal();
      });

      closeButton.addEventListener('click', () => {
        dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        const clickedBackdrop =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (clickedBackdrop) {
          dialog.close();
        }
      });

      return dialog;
    };

    wireDialog({
      dialogSelector: '[data-accessories-dialog]',
      openSelector: '[data-accessories-dialog-open]',
      closeSelector: '[data-accessories-dialog-close]',
    });

    const buyDialog = wireDialog({
      dialogSelector: '[data-buy-dialog]',
      openSelector: '[data-buy-dialog-open]',
      closeSelector: '[data-buy-dialog-close]',
    });

    const variantDataElement = section.querySelector('[data-buy-product-json]');
    const optionSelects = Array.from(section.querySelectorAll('[data-buy-option-select]'));
    const variantIdInput = section.querySelector('[data-buy-variant-id]');
    const priceTarget = section.querySelector('[data-buy-price]');
    const submitButton = section.querySelector('.home-accessories-promo__buy-submit');
    const submitText = section.querySelector('[data-buy-submit-text]');
    const form = section.querySelector('.home-accessories-promo__buy-product-form form');

    if (!variantDataElement || !variantIdInput || !submitButton || !submitText || !form) {
      return;
    }

    const variants = JSON.parse(variantDataElement.textContent);
    const formatMoney = (cents) => {
      const value = Number(cents || 0) / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value);
    };

    const getSelections = () => optionSelects.map((select) => select.value);

    const findVariant = () => {
      if (!optionSelects.length) {
        return variants[0] || null;
      }

      const selections = getSelections();
      return (
        variants.find((variant) =>
          variant.options.every((optionValue, index) => optionValue === selections[index])
        ) || null
      );
    };

    const syncVariantState = () => {
      const variant = findVariant();

      if (!variant) {
        submitButton.setAttribute('disabled', 'disabled');
        submitText.textContent = 'Unavailable';
        return;
      }

      variantIdInput.value = variant.id;

      if (priceTarget) {
        priceTarget.textContent = formatMoney(variant.price);
      }

      if (variant.available) {
        submitButton.removeAttribute('disabled');
        submitText.textContent = 'Add to cart';
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitText.textContent = 'Sold out';
      }
    };

    optionSelects.forEach((select) => {
      select.addEventListener('change', syncVariantState);
    });

    let pendingVariantId = null;

    form.addEventListener('submit', () => {
      pendingVariantId = variantIdInput.value;
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!buyDialog || !buyDialog.open || !pendingVariantId) {
          return;
        }

        if (String(event.productVariantId) === String(pendingVariantId)) {
          pendingVariantId = null;
          buyDialog.close();
        }
      });

      subscribe(PUB_SUB_EVENTS.cartError, () => {
        pendingVariantId = null;
      });
    }

    syncVariantState();
  });
})();
